"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.2745 6.95996C10.7975 7.30004 10.2138 7.50008 9.58329 7.50008C7.97246 7.50008 6.66663 6.19425 6.66663 4.58341C6.66663 2.97258 7.97246 1.66675 9.58329 1.66675C10.6274 1.66675 11.5435 2.21543 12.0587 3.0402M4.99996 16.7394H7.1752C7.45882 16.7394 7.7407 16.7731 8.01564 16.8406L10.314 17.3991C10.8127 17.5206 11.3323 17.5325 11.8362 17.4346L14.3774 16.9402C15.0487 16.8094 15.6663 16.488 16.1502 16.0172L17.9482 14.2682C18.4617 13.7695 18.4617 12.9604 17.9482 12.461C17.4859 12.0113 16.7539 11.9607 16.2309 12.342L14.1355 13.8708C13.8354 14.0902 13.4702 14.2083 13.0947 14.2083H11.0712L12.3592 14.2082C13.0851 14.2082 13.6732 13.6362 13.6732 12.93V12.6744C13.6732 12.088 13.2629 11.5767 12.6784 11.435L10.6905 10.9515C10.3669 10.8731 10.0356 10.8334 9.70258 10.8334C8.89857 10.8334 7.4432 11.4991 7.4432 11.4991L4.99996 12.5208M16.6666 5.41675C16.6666 7.02758 15.3608 8.33341 13.75 8.33341C12.1391 8.33341 10.8333 7.02758 10.8333 5.41675C10.8333 3.80592 12.1391 2.50008 13.75 2.50008C15.3608 2.50008 16.6666 3.80592 16.6666 5.41675ZM1.66663 12.1667L1.66663 17.0001C1.66663 17.4668 1.66663 17.7001 1.75745 17.8784C1.83735 18.0352 1.96483 18.1627 2.12163 18.2426C2.29989 18.3334 2.53325 18.3334 2.99996 18.3334H3.66663C4.13334 18.3334 4.36669 18.3334 4.54495 18.2426C4.70175 18.1627 4.82924 18.0352 4.90913 17.8784C4.99996 17.7001 4.99996 17.4668 4.99996 17.0001V12.1667C4.99996 11.7 4.99996 11.4667 4.90913 11.2884C4.82924 11.1316 4.70175 11.0041 4.54495 10.9242C4.36669 10.8334 4.13334 10.8334 3.66663 10.8334L2.99996 10.8334C2.53325 10.8334 2.29989 10.8334 2.12163 10.9242C1.96483 11.0041 1.83735 11.1316 1.75745 11.2884C1.66663 11.4667 1.66663 11.7 1.66663 12.1667Z",
    stroke: fill,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;